import { useTranslation } from 'react-i18next';

import { Typography } from '@components/typography';

import { NumberTicker } from '@/components/magicui/number-ticker';

function MetricCard({
  title,
  number,
  suffix,
  decimal = false,
}: {
  title: string;
  number: number;
  suffix?: string;
  decimal?: boolean;
}) {
  return (
    <div className="flex flex-col items-center">
      <NumberTicker
        decimalPlaces={decimal ? 1 : 0}
        value={number}
        suffix={suffix}
        className="whitespace-pre-wrap text-4xl lg:text-6xl font-medium tracking-tighter text-black dark:text-white"
      />
      <Typography variant="subtitleMetric">{title}</Typography>
    </div>
  );
}

export function MetricsSection() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full gap-4 lg:mt-10">
      <div className="flex w-full flex-wrap lg:flex-nowrap mt-[2vh] lg:mt-[5vh] gap-4 lg:gap-0">
        <div className="flex w-full lg:w-[50%]">
          <div className="flex-1 shrink-0">
            <MetricCard
              title={t('metriccard1title')}
              number={Number(t('metriccard1value')) || 0}
              suffix="K"
            />
          </div>
          <div className="flex-1 shrink-0">
            <MetricCard
              title={t('metriccard2title')}
              number={Number(t('metriccard2value')) || 0}
              suffix="K"
              decimal
            />
          </div>
        </div>
        <div className="flex w-full lg:w-[50%]">
          <div className="flex-1 shrink-0">
            <MetricCard
              title={t('metriccard3title')}
              number={Number(t('metriccard3value')) || 0}
              suffix="%"
            />
          </div>
          <div className="flex-1 shrink-0">
            <MetricCard title={t('metriccard4title')} number={Number(t('metriccard4value')) || 0} />
          </div>
        </div>
      </div>
    </div>
  );
}
